"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconDocument', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M10 9H6C5.447 9 5 8.553 5 8C5 7.447 5.447 7 6 7H10C10.553 7 11 7.447 11 8C11 8.553 10.553 9 10 9M10 13H6C5.447 13 5 12.553 5 12C5 11.447 5.447 11 6 11H10C10.553 11 11 11.447 11 12C11 12.553 10.553 13 10 13M6 3H8C8.553 3 9 3.447 9 4C9 4.553 8.553 5 8 5H6C5.447 5 5 4.553 5 4C5 3.447 5.447 3 6 3M13.707 3.293L10.707 0.293C10.52 0.105 10.266 0 10 0H3C2.447 0 2 0.447 2 1V15C2 15.553 2.447 16 3 16H13C13.553 16 14 15.553 14 15V4C14 3.734 13.895 3.48 13.707 3.293'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M12.5 11.25H7.5C6.80875 11.25 6.25 10.6912 6.25 10C6.25 9.30875 6.80875 8.75 7.5 8.75H12.5C13.1912 8.75 13.75 9.30875 13.75 10C13.75 10.6912 13.1912 11.25 12.5 11.25M12.5 16.25H7.5C6.80875 16.25 6.25 15.6912 6.25 15C6.25 14.3088 6.80875 13.75 7.5 13.75H12.5C13.1912 13.75 13.75 14.3088 13.75 15C13.75 15.6912 13.1912 16.25 12.5 16.25M7.5 3.75H10C10.6912 3.75 11.25 4.30875 11.25 5C11.25 5.69125 10.6912 6.25 10 6.25H7.5C6.80875 6.25 6.25 5.69125 6.25 5C6.25 4.30875 6.80875 3.75 7.5 3.75M17.1337 4.11625L13.3837 0.36625C13.15 0.13125 12.8325 0 12.5 0H3.75C3.05875 0 2.5 0.55875 2.5 1.25V18.75C2.5 19.4412 3.05875 20 3.75 20H16.25C16.9412 20 17.5 19.4412 17.5 18.75V5C17.5 4.6675 17.3687 4.35 17.1337 4.11625'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M15 13.5H9C8.1705 13.5 7.5 12.8295 7.5 12C7.5 11.1705 8.1705 10.5 9 10.5H15C15.8295 10.5 16.5 11.1705 16.5 12C16.5 12.8295 15.8295 13.5 15 13.5M15 19.5H9C8.1705 19.5 7.5 18.8295 7.5 18C7.5 17.1705 8.1705 16.5 9 16.5H15C15.8295 16.5 16.5 17.1705 16.5 18C16.5 18.8295 15.8295 19.5 15 19.5M9 4.5H12C12.8295 4.5 13.5 5.1705 13.5 6C13.5 6.8295 12.8295 7.5 12 7.5H9C8.1705 7.5 7.5 6.8295 7.5 6C7.5 5.1705 8.1705 4.5 9 4.5M20.5605 4.9395L16.0605 0.4395C15.78 0.1575 15.399 0 15 0H4.5C3.6705 0 3 0.6705 3 1.5V22.5C3 23.3295 3.6705 24 4.5 24H19.5C20.3295 24 21 23.3295 21 22.5V6C21 5.601 20.8425 5.22 20.5605 4.9395'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M20 18H12C10.894 18 10 17.106 10 16C10 14.894 10.894 14 12 14H20C21.106 14 22 14.894 22 16C22 17.106 21.106 18 20 18M20 26H12C10.894 26 10 25.106 10 24C10 22.894 10.894 22 12 22H20C21.106 22 22 22.894 22 24C22 25.106 21.106 26 20 26M12 6H16C17.106 6 18 6.894 18 8C18 9.106 17.106 10 16 10H12C10.894 10 10 9.106 10 8C10 6.894 10.894 6 12 6M27.414 6.586L21.414 0.586C21.04 0.21 20.532 0 20 0H6C4.894 0 4 0.894 4 2V30C4 31.106 4.894 32 6 32H26C27.106 32 28 31.106 28 30V8C28 7.468 27.79 6.96 27.414 6.586'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;